import { useSubscription } from '@apollo/react-hooks';

import { graphqlSchema } from '../../../services/graphql.schema';
import GraphQlClient from '../../../services/graphql';

function AccountSubscriptionManager(): null {
    useSubscription(graphqlSchema.FISCALPOP.STRIPE.SUBSCRIPTIONS.billingAccountUpdated, {
        onSubscriptionData: ({ subscriptionData }) => {
            console.log('[AccountSubscriptionManager] billingAccountUpdated', subscriptionData.data?.billingAccountUpdated);
            GraphQlClient.recallCurrentUser();
        }
    });

    useSubscription(graphqlSchema.FISCALPOP.STRIPE.SUBSCRIPTIONS.billingAccountSubscriptionUpdated, {
        onSubscriptionData: ({ subscriptionData }) => {
            console.log('[AccountSubscriptionManager] billingAccountSubscriptionUpdated', subscriptionData.data?.billingAccountSubscriptionUpdated);
            GraphQlClient.recallCurrentUser();
        }
    });

    useSubscription(graphqlSchema.FISCALPOP.STRIPE.SUBSCRIPTIONS.speiPaymentRequested, {
        onSubscriptionData: ({ subscriptionData }) => {
            console.log('[AccountSubscriptionManager] speiPaymentRequested', subscriptionData.data?.speiPaymentRequested);
            GraphQlClient.recallCurrentUser();
        }
    });

    return null;
}

export default AccountSubscriptionManager;
